import initCarousel from '../helpers/carousel';

export default class DynamicTestimonials {
  constructor(section) {
    this.el = section.el;
    this.section = section;

    const selectors = {
      testimonialsCarousel: '[data-testimonials-carousel]',
      testimonialsMedia: '[data-testimonials-media]',
      prevButton: '.splide__arrow--prev',
      nextButton: '.splide__arrow--next',
      currentCounter: '[data-testimonials-current]',
    };

    this.testimonialsCarousel = this.el.querySelector(
      selectors.testimonialsCarousel,
    );
    this.testimonialsMedia = this.el.querySelector(selectors.testimonialsMedia);
    this.prevButton = this.el.querySelector(selectors.prevButton);
    this.nextButton = this.el.querySelector(selectors.nextButton);
    this.currentCounter = this.el.querySelector(selectors.currentCounter);

    this._initCarousels();
    this._bindEvents();
  }

  _initCarousels() {
    if (!this.testimonialsCarousel || !this.testimonialsMedia) {
      return;
    }

    /** Initialize content carousel */
    this.mainCarousel = initCarousel(
      this.testimonialsCarousel,
      {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        gap: '1rem',
        pagination: false,
        arrows: false,
      },
      true,
    );

    /** Initialize media carousel */
    this.mediaCarousel = initCarousel(
      this.testimonialsMedia,
      {
        type: 'fade',
        perPage: 1,
        perMove: 1,
        gap: '1rem',
        pagination: false,
        arrows: false,
        drag: false,
      },
      true,
    );

    /** Sync both carousels */
    if (this.mainCarousel && this.mediaCarousel) {
      this.mainCarousel.sync(this.mediaCarousel);
    }
  }

  _bindEvents() {
    if (this.prevButton && this.nextButton && this.mainCarousel) {
      this.prevButton.addEventListener('click', () => {
        if (!this.prevButton.disabled) {
          this.mainCarousel.go('<');
        }
      });

      this.nextButton.addEventListener('click', () => {
        if (!this.nextButton.disabled) {
          this.mainCarousel.go('>');
        }
      });
    }
  }
}
